export interface Props {
  desc?: string;
  color?: string;
  textColor?: string;
}

export default function Header({ color, desc, textColor = "black" }: Props) {
  return (
    <div
      id="header"
      className={`${
        color && color
      } relative w-full flex md:gap-4 py-5 justify-start items-center  md:px-15 lg:px-20 xl:px-30 px-6`}
    >
      <p className={`lg:text-xl md:text-base text-sm text-${textColor} font-Regular text-start`}>
        {desc}
      </p>
    </div>
  );
}
